// Countries where domestic mobile numbers typically appear with a leading '0'.
const COUNTRIES_WITH_LEADING_ZERO_MOBILE = new Set<string>([
  // Southeast Asia
  'MY', // Malaysia
  'ID', // Indonesia
  'TH', // Thailand
  'PH', // Philippines
  'VN', // Vietnam

  // East Asia & Oceania
  'JP', // Japan (090/080/070)
  'AU', // Australia (04xx)
  'NZ', // New Zealand (02x)

  // Europe (many use 0 domestically, but mobile specifics vary—include where mobiles commonly present with 0)
  'GB', // United Kingdom (07xxx)
  'IE', // Ireland (08x)
  'FR', // France (06/07)
  'DE', // Germany (01x/015/016/017 mobile ranges)
  'BE', // Belgium (04xx mobile)
  'NL', // Netherlands (06)
  'SE', // Sweden (07x) – many users expect a leading 0 domestically
  'NO', // Norway (04x/9x often shown with 0 domestically)
  'IT', // Italy: mobiles usually start with 3xx (no 0). Consider removing if you prefer strictness.

  // Middle East & Africa
  'ZA', // South Africa (06/07/08 often with 0 domestically)
  'NG', // Nigeria (0 prefix domestically common)
  'TR', // Turkey (05xx)
  'SA', // Saudi Arabia (05x)
  'AE', // UAE (05x)

  // Americas – generally do NOT use leading 0 for domestic mobiles; keep out unless you have a local rule
  // 'US', 'CA', 'BR', 'MX' => intentionally excluded
]);

export function includeCountryLeadingZero(value: string | number | null, country: string = 'MY'): string {
  const iso2 = (country || '').toUpperCase();
  const s = (value ?? '').toString().trim();
  return COUNTRIES_WITH_LEADING_ZERO_MOBILE.has(iso2) ? ensureLeadingZero(s) : s;
}

/**
 * Ensures the given value has a leading "0".
 * - If it already starts with "0", returns it unchanged.
 * - If it's empty/whitespace, returns "0".
 * - Otherwise, prefixes a single "0".
 */
export function ensureLeadingZero(value: string | number | null): string {
  const s = (value ?? '').toString().trim();
  if (s.length === 0) return '0';
  return s.startsWith('0') ? s : `0${s}`;
}
